// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes ink-enter {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
.public-work-overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(2, 3, 8, 0.6);
  pointer-events: none;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
}

.public-work-panel {
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  color: #ebe8e1;
  background: rgba(11, 15, 19, 0.96);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(6px);
  pointer-events: auto;
  width: clamp(460px, 36vw, 620px);
  max-height: 82vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  animation: ink-enter 0.16s ease-out;
}
.public-work-panel * {
  box-sizing: border-box;
}
@media (prefers-reduced-motion: reduce) {
  .public-work-panel {
    animation: none;
  }
}

.public-work-header {
  flex: 0 0 auto;
  padding: 18px 24px 14px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
}

.public-work-title {
  font-family: "Marcellus", "Cinzel", Georgia, serif;
  font-weight: 400;
  font-size: 26px;
  line-height: 1.15;
  letter-spacing: 0.01em;
  color: #ebe8e1;
}

.public-work-body {
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;
  flex: 1 1 auto;
  min-height: 0;
  padding: 8px 24px;
  scrollbar-gutter: stable;
}
.public-work-body::-webkit-scrollbar {
  width: 6px;
}
.public-work-body::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
}

.public-work-empty {
  padding: 18px 0;
  font-size: 14px;
  color: #8d8a82;
}

.public-work-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.public-work-offer {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 14px 0;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
}
.public-work-offer:first-child {
  border-top-color: transparent;
}
.public-work-offer-main {
  flex: 1 1 auto;
  min-width: 0;
}
.public-work-offer-name {
  font-family: "Marcellus", "Cinzel", Georgia, serif;
  font-weight: 400;
  font-size: 18px;
  line-height: 1.15;
  letter-spacing: 0.01em;
  color: #ebe8e1;
}
.public-work-offer-route {
  margin-top: 4px;
  font-size: 15px;
  font-weight: 600;
  color: var(--gold-light);
}
.public-work-offer-meta {
  margin-top: 2px;
  font-size: 13px;
  line-height: 1.5;
  color: #8d8a82;
  font-variant-numeric: tabular-nums;
}

.public-work-status {
  padding: 14px 0 8px;
}
.public-work-status-name {
  font-family: "Marcellus", "Cinzel", Georgia, serif;
  font-weight: 400;
  font-size: 20px;
  line-height: 1.15;
  letter-spacing: 0.01em;
  color: #ebe8e1;
  margin-bottom: 10px;
}

.public-work-facts {
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 6px;
  margin: 0;
  padding: 4px 14px;
}
.public-work-facts > div {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  padding: 9px 0;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
}
.public-work-facts > div:first-child {
  border-top: 0;
}
.public-work-facts dt {
  font-size: 13px;
  font-weight: 600;
  color: #aeaba2;
  flex-shrink: 0;
}
.public-work-facts dd {
  margin: 0;
  font-size: 14px;
  text-align: right;
  color: #ebe8e1;
  font-variant-numeric: tabular-nums;
}

.public-work-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 14px;
}

.public-work-warn {
  color: #d9786d;
}

.public-work-footer {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 24px 16px;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
}

.public-work-limits {
  display: flex;
  flex-direction: column;
  gap: 2px;
  font-size: 13px;
  line-height: 1.5;
  color: #8d8a82;
  font-variant-numeric: tabular-nums;
}

.public-work-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 14px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;
}
.public-work-btn:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.12);
  border-color: var(--gold-dark);
}
.public-work-btn:active:not(:disabled) {
  transform: translateY(1px);
}
.public-work-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.public-work-btn:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: 2px;
}
.public-work-btn--danger {
  color: #d9786d;
  background: transparent;
  border-color: rgba(217, 120, 109, 0.45);
}
.public-work-btn--danger:hover:not(:disabled) {
  background: rgba(217, 120, 109, 0.14);
  border-color: #d9786d;
}
.public-work-btn--quiet {
  color: #8d8a82;
  background: transparent;
  border-color: transparent;
}
.public-work-btn--quiet:hover:not(:disabled) {
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.07);
  border-color: transparent;
}`, "",{"version":3,"sources":["webpack://./src/theme/_ink.scss","webpack://./src/features/publicWork/styles.scss"],"names":[],"mappings":"AAmLA;EACE;IAAO,UAAA;IAAY,0BAAA;EChLnB;EDiLA;IAAO,UAAA;IAAY,eAAA;EC7KnB;AACF;AANA;EACE,eAAA;EACA,QAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,8BAAA;EACA,oBAAA;EACA,yDDkBU;ACVZ;;AALA;EDkBE,yDAHU;EAIV,cAbK;EAoBL,kCAzBI;EA0BJ,0CAAA;EACA,kBAjBO;EAkBP,0CAAA;EACA,0BAAA;EC5BA,oBAAA;EACA,gCAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EDwJA,mCAAA;ACzIF;ADFE;EAAI,sBAAA;ACKN;ADwIE;ECjKF;IDiK4C,eAAA;ECpI1C;AACF;;AAnBA;EACE,cAAA;EACA,uBAAA;EACA,kDAAA;AAsBF;;AAnBA;EDwBE,kDA3BW;EA4BX,gBAAA;EACA,eCzBmB;ED0BnB,iBAAA;EACA,sBAAA;EACA,cAxCK;ACuCP;;AAxBA;EDiIE,gBAAA;EACA,qBAAA;EACA,qDAAA;ECjIA,cAAA;EACA,aAAA;EACA,iBAAA;EACA,wBAAA;AA6BF;ADmGE;EAAuB,UAAA;AChGzB;ADiGE;EAA6B,oCAAA;EAAsC,kBAAA;AC7FrE;;AAjCA;EACE,eAAA;EACA,eAAA;EACA,cDxBO;AC4DT;;AAjCA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;AAoCF;;AAjCA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,+CAAA;AAoCF;AAlCE;EAAgB,6BAAA;AAqClB;AAnCE;EACE,cAAA;EACA,YAAA;AAqCJ;AAlCE;EDdA,kDA3BW;EA4BX,gBAAA;EACA,eCaqB;EDZrB,iBAAA;EACA,sBAAA;EACA,cAxCK;AC2FP;AAtCE;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,wBAAA;AAwCJ;AArCE;EACE,eAAA;EDXF,eAAA;EACA,gBAAA;EACA,cAlDO;EC6DL,kCAAA;AAyCJ;;AArCA;EACE,mBAAA;AAwCF;AAtCE;EDnCA,kDA3BW;EA4BX,gBAAA;EACA,eCkCqB;EDjCrB,iBAAA;EACA,sBAAA;EACA,cAxCK;ECwEH,mBAAA;AA6CJ;;AAzCA;ED/CE,qCAjCW;EAkCX,2CAAA;EACA,kBA1BO;ECyEP,SAAA;EACA,iBAAA;AA8CF;AA5CE;EACE,aAAA;EACA,8BAAA;EACA,SAAA;EACA,cAAA;EACA,+CAAA;AA8CJ;AA5CI;EAAgB,aAAA;AA+CpB;AA5CE;EDnCA,eAAA;EACA,gBAAA;EACA,cAzDO;EC4FL,cAAA;AAgDJ;AA7CE;EACE,SAAA;EACA,eAAA;EACA,iBAAA;EACA,cDpGG;ECqGH,kCAAA;AA+CJ;;AA3CA;EACE,aAAA;EACA,yBAAA;EACA,gBAAA;AA8CF;;AA3CA;EACE,cD7GO;AC2JT;;AA3CA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,uBAAA;EACA,+CAAA;AA8CF;;AA3CA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;ED9EA,eAAA;EACA,gBAAA;EACA,cAlDO;ECgIP,kCAAA;AAgDF;;AA7CA;EDtEE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,iBAAA;EACA,yDA3DU;EA4DV,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAzEK;EA0EL,qCAAA;EACA,0CAAA;EACA,kBAvEO;EAwEP,eAAA;EACA,kFAAA;ACuHF;ADrHE;EAAyB,qCAAA;EAAuC,8BAAA;ACyHlE;ADxHE;EAA0B,0BAAA;AC2H5B;AD1HE;EAAa,YAAA;EAAc,mBAAA;AC8H7B;AD7HE;EAAkB,oCAAA;EAAsC,mBAAA;ACiI1D;AA5EE;EDzCA,cA5FO;EA6FP,uBAAA;EACA,uCAAA;ACwHF;ADtHE;EAAyB,qCAAA;EAAuC,qBAhGzD;AC0NT;AApFE;EDlCA,cArGO;EAsGP,uBAAA;EACA,yBAAA;ACyHF;ADvHE;EAAyB,cA3GpB;EA2GkC,qCAAA;EAAuC,yBAAA;AC4HhF","sourcesContent":["// Shared look of the redesigned interfaces (escape menu, ALT menu, housing\n// drawer, and every other panel brought in line with them).\n//\n// Usage from any component stylesheet:\n//   @use '../../theme/ink' as ink;      // adjust the relative path\n//   .my-panel { @include ink.panel; }\n//\n// Rules the whole UI follows:\n//   - ink background, 1px light border, ONE corner radius (6px)\n//   - accent colour only through the palette tokens --gold-main/-light/-dark\n//     (never a hard-coded gold hex), so the palette picker keeps working\n//   - Marcellus for titles, Din-pro for everything else\n//   - no ornaments, no emoji, no centred decorative rules\n//   - hover and focus states on every control, reduced-motion respected\n//   - no color-mix() / relative colour syntax (older CEF in game)\n\n$ink: rgba(11, 15, 19, 0.96);\n$ink-raised: rgba(255, 255, 255, 0.04);\n$ink-field: rgba(0, 0, 0, 0.35);\n$line: rgba(255, 255, 255, 0.12);\n$line-strong: rgba(255, 255, 255, 0.2);\n$text: #ebe8e1;\n$text-2: #aeaba2;\n$text-3: #8d8a82;\n$danger: #d9786d;\n$success: #8fbf8a;\n$radius: 6px;\n$on-accent: #14100a;\n\n$font-title: 'Marcellus', 'Cinzel', Georgia, serif;\n$font-text: 'Din-pro', 'Segoe UI', system-ui, sans-serif;\n\n@mixin base {\n  font-family: $font-text;\n  color: $text;\n  * { box-sizing: border-box; }\n}\n\n// Floating panel (modals, centred prompts, docked windows).\n@mixin panel {\n  @include base;\n  background: $ink;\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.6);\n  backdrop-filter: blur(6px);\n}\n\n// Raised block inside a panel.\n@mixin block {\n  background: $ink-raised;\n  border: 1px solid $line;\n  border-radius: $radius;\n}\n\n@mixin title($size: 22px) {\n  font-family: $font-title;\n  font-weight: 400;\n  font-size: $size;\n  line-height: 1.15;\n  letter-spacing: 0.01em;\n  color: $text;\n}\n\n@mixin lead {\n  font-size: 14px;\n  line-height: 1.5;\n  color: $text-2;\n}\n\n@mixin hint {\n  font-size: 13px;\n  line-height: 1.5;\n  color: $text-3;\n}\n\n@mixin label {\n  font-size: 13px;\n  font-weight: 600;\n  color: $text-2;\n}\n\n// Buttons: neutral by default; add the modifiers below for the other kinds.\n@mixin button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 8px 14px;\n  font-family: $font-text;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.2;\n  white-space: nowrap;\n  color: $text;\n  background: rgba(255, 255, 255, 0.07);\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  cursor: pointer;\n  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;\n\n  &:hover:not(:disabled) { background: rgba(255, 255, 255, 0.12); border-color: var(--gold-dark); }\n  &:active:not(:disabled) { transform: translateY(1px); }\n  &:disabled { opacity: 0.4; cursor: not-allowed; }\n  &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: 2px; }\n}\n\n@mixin button-primary {\n  color: $on-accent;\n  background: var(--gold-main);\n  border-color: var(--gold-main);\n\n  &:hover:not(:disabled) { background: var(--gold-light); border-color: var(--gold-light); }\n}\n\n@mixin button-danger {\n  color: $danger;\n  background: transparent;\n  border-color: rgba(217, 120, 109, 0.45);\n\n  &:hover:not(:disabled) { background: rgba(217, 120, 109, 0.14); border-color: $danger; }\n}\n\n@mixin button-quiet {\n  color: $text-3;\n  background: transparent;\n  border-color: transparent;\n\n  &:hover:not(:disabled) { color: $text; background: rgba(255, 255, 255, 0.07); border-color: transparent; }\n}\n\n@mixin button-sm {\n  padding: 5px 10px;\n  font-size: 13px;\n}\n\n@mixin field {\n  width: 100%;\n  padding: 9px 11px;\n  font-family: $font-text;\n  font-size: 14px;\n  color: $text;\n  background: $ink-field;\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  user-select: text;\n\n  &:focus { outline: none; border-color: var(--gold-main); }\n  &::placeholder { color: $text-3; font-family: $font-text; text-transform: none; letter-spacing: normal; opacity: 1; }\n}\n\n// Pill-shaped counters are the only rounded exception (small badges).\n@mixin badge {\n  display: inline-block;\n  min-width: 20px;\n  padding: 1px 7px;\n  font-size: 12px;\n  font-weight: 600;\n  text-align: center;\n  color: $text-2;\n  background: rgba(255, 255, 255, 0.09);\n  border-radius: 10px;\n}\n\n@mixin scroll {\n  overflow-y: auto;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;\n\n  &::-webkit-scrollbar { width: 6px; }\n  &::-webkit-scrollbar-thumb { background: rgba(255, 255, 255, 0.2); border-radius: 3px; }\n}\n\n@mixin enter($from: translateY(8px)) {\n  animation: ink-enter 0.16s ease-out;\n\n  @media (prefers-reduced-motion: reduce) { animation: none; }\n}\n\n@keyframes ink-enter {\n  from { opacity: 0; transform: translateY(8px); }\n  to   { opacity: 1; transform: none; }\n}\n\n// Tabs (underline style, as in the housing drawer).\n@mixin tab {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 9px 12px;\n  margin-bottom: -1px;\n  font-family: $font-text;\n  font-size: 14px;\n  font-weight: 600;\n  color: $text-2;\n  background: transparent;\n  border: 0;\n  border-bottom: 2px solid transparent;\n  cursor: pointer;\n\n  &:hover { color: $text; }\n  &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: -2px; }\n}\n\n@mixin tab-active {\n  color: var(--gold-light);\n  border-bottom-color: var(--gold-main);\n}\n","// Public work panel. Centred modal, ink look (see theme/_ink.scss).\n@use '../../theme/ink' as ink;\n\n.public-work-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 9999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(2, 3, 8, 0.6);\n  pointer-events: none;\n  font-family: ink.$font-text;\n}\n\n.public-work-panel {\n  @include ink.panel;\n  pointer-events: auto;\n  width: clamp(460px, 36vw, 620px);\n  max-height: 82vh;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  @include ink.enter;\n}\n\n.public-work-header {\n  flex: 0 0 auto;\n  padding: 18px 24px 14px;\n  border-bottom: 1px solid ink.$line;\n}\n\n.public-work-title {\n  @include ink.title(26px);\n}\n\n.public-work-body {\n  @include ink.scroll;\n  flex: 1 1 auto;\n  min-height: 0;\n  padding: 8px 24px;\n  scrollbar-gutter: stable;\n}\n\n.public-work-empty {\n  padding: 18px 0;\n  font-size: 14px;\n  color: ink.$text-3;\n}\n\n.public-work-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.public-work-offer {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding: 14px 0;\n  border-top: 1px solid ink.$line;\n\n  &:first-child { border-top-color: transparent; }\n\n  &-main {\n    flex: 1 1 auto;\n    min-width: 0;\n  }\n\n  &-name {\n    @include ink.title(18px);\n  }\n\n  &-route {\n    margin-top: 4px;\n    font-size: 15px;\n    font-weight: 600;\n    color: var(--gold-light);\n  }\n\n  &-meta {\n    margin-top: 2px;\n    @include ink.hint;\n    font-variant-numeric: tabular-nums;\n  }\n}\n\n.public-work-status {\n  padding: 14px 0 8px;\n\n  &-name {\n    @include ink.title(20px);\n    margin-bottom: 10px;\n  }\n}\n\n.public-work-facts {\n  @include ink.block;\n  margin: 0;\n  padding: 4px 14px;\n\n  > div {\n    display: flex;\n    justify-content: space-between;\n    gap: 16px;\n    padding: 9px 0;\n    border-top: 1px solid ink.$line;\n\n    &:first-child { border-top: 0; }\n  }\n\n  dt {\n    @include ink.label;\n    flex-shrink: 0;\n  }\n\n  dd {\n    margin: 0;\n    font-size: 14px;\n    text-align: right;\n    color: ink.$text;\n    font-variant-numeric: tabular-nums;\n  }\n}\n\n.public-work-actions {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 14px;\n}\n\n.public-work-warn {\n  color: ink.$danger;\n}\n\n.public-work-footer {\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 12px 24px 16px;\n  border-top: 1px solid ink.$line;\n}\n\n.public-work-limits {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  @include ink.hint;\n  font-variant-numeric: tabular-nums;\n}\n\n.public-work-btn {\n  @include ink.button;\n\n  &--danger { @include ink.button-danger; }\n  &--quiet { @include ink.button-quiet; }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
